import { RootState } from 'core/redux/types';

export function isQuoteModalOpen(state: RootState): boolean {
    return state.quoteModal.open;
}
